export const LANGUAGE_OPTIONS = [
    {
        name: 'English',
        value: 'en'
    },
    {
        name: 'Spanish',
        value: 'es'
    },
    {
        name: 'Portuguese',
        value: 'pt'
    },
    {
        name: 'French',
        value: 'fr'
    },
    {
        name: 'German',
        value: 'de'
    },
    {
        name: 'Swedish',
        value: 'sv'
    }
];
